/* insta-share.js — share button for the Instagram-style product cards/PDP.
   Uses the Web Share API when available, else copies the URL to the clipboard. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ig-share]');
    if (!btn) return;
    e.preventDefault();
    var path = btn.getAttribute('data-path') || location.pathname;
    var url = path.indexOf('http') === 0 ? path : (location.origin + path);
    var title = btn.getAttribute('data-title') || document.title;
    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
      return;
    }
    var done = function () {
      btn.classList.add('is-copied');
      var label = btn.querySelector('.igp__share-label');
      if (label) { var t = label.textContent; label.textContent = 'Link copied!'; setTimeout(function () { label.textContent = t; btn.classList.remove('is-copied'); }, 1600); }
      else { setTimeout(function () { btn.classList.remove('is-copied'); }, 1600); }
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () { window.prompt('Copy this link:', url); });
    } else {
      window.prompt('Copy this link:', url);
    }
  });
})();

/* Instagram carousel dots — sync the active dot with the swiped slide. */
(function () {
  var raf;
  function update(car) {
    var dots = car.parentElement && car.parentElement.querySelector('.igp__dots');
    if (!dots) return;
    var i = Math.round(car.scrollLeft / Math.max(1, car.clientWidth));
    dots.querySelectorAll('.igp__dot').forEach(function (d, di) { d.classList.toggle('is-on', di === i); });
  }
  document.addEventListener('scroll', function (e) {
    var car = e.target && e.target.closest && e.target.closest('[data-igp-carousel]');
    if (!car) return;
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { update(car); });
  }, true);
})();
